/**
 * WorkSpace Icon — "Arbeit" Life Space
 *
 * Briefcase icon from Figma design.
 * Compatible with Lucide icon API (size + color props).
 *
 * Two states: monochrome (default) and the fixed full-color Figma variant via
 * `colored` (e.g. the list-mode project switcher).
 *
 * @example
 * <WorkSpaceIcon size={16} />
 * <WorkSpaceIcon size={16} colored />
 */
export const WorkSpaceIcon = ({ size = 16, color, colored = false }: { size?: number; color?: string; colored?: boolean }) => {
  if (colored) {
    return (
      <svg width={size} height={size} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.66504 3.66406V0.664062H10.665V3.66406" stroke="#4338CA" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M1.66504 3.66406H14.665C14.9303 3.66406 15.1846 3.76942 15.3721 3.95696C15.5597 4.14449 15.665 4.39885 15.665 4.66406V9.66406H0.665039V4.66406C0.665039 4.39885 0.770396 4.14449 0.957932 3.95696C1.14547 3.76942 1.39982 3.66406 1.66504 3.66406Z"
          fill="#818CF8" stroke="#4338CA" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"
        />
        <path
          d="M14.665 11.6641V13.6641C14.665 13.9293 14.5597 14.1836 14.3721 14.3712C14.1846 14.5587 13.9303 14.6641 13.665 14.6641H2.66504C2.39982 14.6641 2.14547 14.5587 1.95793 14.3712C1.7704 14.1836 1.66504 13.9293 1.66504 13.6641V11.6641"
          fill="#C7D2FE"
        />
        <path
          d="M14.665 11.6641V13.6641C14.665 13.9293 14.5597 14.1836 14.3721 14.3712C14.1846 14.5587 13.9303 14.6641 13.665 14.6641H2.66504C2.39982 14.6641 2.14547 14.5587 1.95793 14.3712C1.7704 14.1836 1.66504 13.9293 1.66504 13.6641V11.6641"
          stroke="#4338CA" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"
        />
      </svg>
    )
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.67 3.67V0.67H10.66V3.67"
        stroke={color || 'currentColor'}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.67 3.67H14.66C14.93 3.67 15.18 3.77 15.37 3.96C15.56 4.15 15.66 4.4 15.66 4.67V9.67H0.67V4.67C0.67 4.4 0.77 4.15 0.96 3.96C1.15 3.77 1.4 3.67 1.67 3.67Z"
        stroke={color || 'currentColor'}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.66 11.66V13.66C14.66 13.93 14.56 14.18 14.37 14.37C14.18 14.56 13.93 14.66 13.66 14.66H2.67C2.4 14.66 2.15 14.56 1.96 14.37C1.77 14.18 1.67 13.93 1.67 13.66V11.66"
        stroke={color || 'currentColor'}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
